import React, { useState } from "react";
import { Document, Page } from "react-pdf";
import Div from "../../components/common/Div";

export default function GlobalInfo() {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
    <Div>
      <Document file={""} onLoadSuccess={onDocumentLoadSuccess}>
        <Page pageNumber={pageNumber} />
      </Document>
      <p>
        Page {pageNumber} of {numPages}
      </p>
    </Div>
  );
}
